import { useEffect } from "react";
import Head from "next/head";

import ShyftPassSingleClassPage from "@/containers/ShyftPassSingleClassPage";

import { appendHotJarScript } from "@/utils";

//Redux
import * as actions from "@/redux/ShyftPassReducer";
import { wrapper } from "@/redux/Store";

const ShyftPassSingleClass = () => {
  //FOR HOTJAR TRACKING
  useEffect(() => {
    const isProduction = process.env.NEXT_PUBLIC_SENTRY_ENV === "production";
    const { head, script } = appendHotJarScript(isProduction);

    return () => {
      if (isProduction && head && script) head.removeChild(script);
    };
  }, []);

  return (
    <>
      <Head>
        <title>
          Shyft Pass - Weekend Workouts, Community Mixers, Latest Wellness
          Products
        </title>
        <meta
          name="description"
          content="Shyft Pass | The best health and wellness membership that provides exclusive access to weekend workouts, community mixers, latest wellness products"
        />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="Shyft Pass - Weekend Workouts, Community Mixers, Latest Wellness Products"
        />
        <meta
          property="og:description"
          content="Shyft Pass | The best health and wellness membership that provides exclusive access to weekend workouts, community mixers, latest wellness products"
        />
        <meta
          property="og:url"
          key="og:url"
          content="https://www.betheshyft.com/shyftpass/single-class/"
        />
        <meta property="og:site_name" content="Shyftpass" />
        <meta
          property="og:image"
          content="https://d1mxd7n691o8sz.cloudfront.net/static/mindhouse/imagerepo/2023-11/shyftpass_meta_image-8fd0ae1bf8fa4c3db2bd4d9e7ba64a81.jpg"
        />
        <meta name="twitter:card" content="summary_large_image" />
      </Head>
      <main id="shyftpass-single-class-page">
        <ShyftPassSingleClassPage />
      </main>
    </>
  );
};

export default ShyftPassSingleClass;

export const getServerSideProps = wrapper.getServerSideProps(
  (store) => async () => {
    await store.dispatch(actions.getShyftPassScheduleData({}));
  }
);
